/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function changeSlide(direction, parent) {
  //console.log(direction, parent);
}
function addToCart(variantId, button) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    setTimeout(function() {
      button.classList.remove('is-added');
    }, 1000);
    //console.log('Product added to cart:', data);
  })
  .catch(error => {
    button.classList.remove('is-loading');
    console.error('Error adding product to cart:', error);
  });
}

function atcUpdateVariant(sel) {
  var selectedOption = sel.options[sel.selectedIndex];
  var isAvailable = selectedOption.getAttribute('data-available');
  var price = selectedOption.getAttribute('data-price');
  var comparePrice = selectedOption.getAttribute('data-compare_at_price');
  
  // Get the form and button
  var form = sel.closest('form');
  var button = form.querySelector('.product-atc-button');

  var container = form.closest('.product-item');
  var price_container = container.querySelector('.price');
  // Remove 'sale' class from price container if it exists
  price_container.classList.remove('sale');

  new_price = '<span class="new-price">' + price + '</span>';
  if (comparePrice) {
    price_container.classList.add('sale');
    new_price += '<span class="old-price">' + comparePrice + '</span>';
  }
  //console.log('form', form, 'price_container', price_container);
  price_container.innerHTML = new_price;

  // Update button state based on availability
  if (isAvailable === 'false') {
    button.disabled = true;
    button.querySelector('.btn__text').textContent = 'Sold Out';
  } else {
    button.disabled = false;
    button.querySelector('.btn__text').textContent = 'Add';
  }
}

function atcClick(button) {
  button.classList.add('is-loading');
  var variantIdField = button.closest('form').querySelector('input[name="id"], select[name="id"]');

  if (variantIdField) {
    var variantId = variantIdField.value;
    //console.log('variantId', variantId);
    if (variantId) {
      addToCart(variantId, button);
    }
  } else {
    button.classList.remove('is-loading');
  }
}

(function(Flickity, PhotoSwipe) {
  // Add custom code below this line

  document.querySelectorAll('.toggle-video-sound').forEach((button) => {
    //console.log(button);
    button.addEventListener('click', () => {
        //console.log('click');
      let target_vid = button.dataset.video;
        
    let video = document.querySelector('[data-video-id="' + target_vid + '"] video');
    let is_muted = video.muted;
        if (is_muted) {
            button.classList.add('toggle-video-sound--on');
            button.setAttribute('aria-label', 'Mute sound');
        } else {
            button.classList.remove('toggle-video-sound--on');
            button.setAttribute('aria-label', 'Enable sound');
        }
        video.muted = !is_muted;
     });
  });

  // Override HTMLVideoElement.play() so theme IntersectionObservers cannot
  // autoplay videos once the user has chosen to pause on this page.
  let _userPausedVideos = false;
  const _nativeVideoPlay = HTMLVideoElement.prototype.play;
  HTMLVideoElement.prototype.play = function() {
    if (_userPausedVideos && !this._userInitiatedPlay) {
      return Promise.resolve();
    }
    return _nativeVideoPlay.call(this);
  };

  function pauseAllPageVideos() {
    _userPausedVideos = true;
    // Pause every VideoBackground on the page and disconnect its play observer
    document.querySelectorAll('[data-video-id]').forEach((bg) => {
      const vid = bg.querySelector('video');
      if (vid) {
        vid.pause();
        vid.removeAttribute('autoplay');
      }
      if (bg.videoPlayObserver) {
        bg.videoPlayObserver.disconnect();
      }
    });
    // Sync all play-pause buttons to paused state
    document.querySelectorAll('.play-pause-video').forEach((btn) => {
      btn.classList.add('play-pause-video--paused');
      btn.setAttribute('aria-label', 'Play video');
    });
  }

  document.querySelectorAll('.play-pause-video').forEach((button) => {
    console.log(button);
    button.addEventListener('click', () => {
      console.log('click');
      let target_vid = button.dataset.video;

      let videoBackground = document.querySelector('[data-video-id="' + target_vid + '"]');
      let video = videoBackground ? videoBackground.querySelector('video') : null;
      console.log('video', video);

      if (!video) return;

      let is_playing = !video.paused;
      console.log('is_playing', is_playing);

      if (is_playing) {
        // User is pausing — pause all videos
        pauseAllPageVideos();
      } else {
        // User explicitly resuming — clear the flag and play this video
        _userPausedVideos = false;
        button.classList.remove('play-pause-video--paused');
        button.setAttribute('aria-label', 'Pause video');
        video._userInitiatedPlay = true;
        video.play();
        video._userInitiatedPlay = false;
      }
    });
  });

  document.querySelectorAll('.video-gallery__play-btn').forEach(video_btn => {
    video_btn.addEventListener('click', function(e) {
      //console.log('click');
      e.preventDefault();
      const videoContainer = video_btn.closest('.video-gallery__video');
      const video = videoContainer.querySelector('video');
      
      if (video) {
        video.style.display = 'block';
        video._userInitiatedPlay = true;
        video.play();
        video.focus();
        video._userInitiatedPlay = false;
        video_btn.style.display = 'none';
      }
    });
  });

  var arrow_svg = '<svg width="30" height="14" viewBox="0 0 30 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.2185 6.99991L0.999983 6.99991" stroke="black" stroke-linecap="square" stroke-linejoin="round"/><path d="M22.7798 1L29 7L22.7798 13" stroke="black" stroke-linecap="square" stroke-linejoin="round"/></svg>';

  var loadSliderNav = function(slider, prevSelector, nextSelector, parent_container) {
    var prevButtons = document.querySelectorAll(prevSelector);
    var nextButtons = document.querySelectorAll(nextSelector);
    if (parent_container != null) {
      prevButtons = parent_container.querySelectorAll(prevSelector);
      nextButtons = parent_container.querySelectorAll(nextSelector);
    }

    prevButtons.forEach(function(prevButton) {
      prevButton.addEventListener('click', function() {
        slider.previous();
        //updateButtons();
      });
    });

    nextButtons.forEach(function(nextButton) {
      nextButton.addEventListener('click', function() {
        slider.next();
        //updateButtons();
      });
    });

    function updateButtons() {
      prevButtons.forEach(function(prevButton) {
        if (slider.selectedIndex === 0) {
          prevButton.disabled = true;
        } else {
          prevButton.disabled = false;
        }
      });

      nextButtons.forEach(function(nextButton) {
        if (slider.selectedIndex === slider.slides.length - 1) {
          nextButton.disabled = true;
        } else {
          nextButton.disabled = false;
        }
      });
    }

    // Initial button state update
    //updateButtons();
  };

  var focusableSelectors = 'a[href], button, input, select, textarea, area[href], [tabindex]';

  function syncInertToAriaHidden(flkty) {
    console.log('flkty', flkty);
    flkty.getCellElements().forEach(cell => {
      const hidden = cell.getAttribute('aria-hidden') === 'true';
      if (hidden) {
        cell.setAttribute('tabindex', '-1');
        cell.querySelectorAll(focusableSelectors).forEach(el => {
          if (!el.hasAttribute('data-tabindex-saved')) {
            el.setAttribute('data-tabindex-saved', el.getAttribute('tabindex') ?? '');
          }
          el.setAttribute('tabindex', '-1');
        });
      } else {
        cell.removeAttribute('tabindex');
        cell.querySelectorAll(focusableSelectors).forEach(el => {
          if (el.hasAttribute('data-tabindex-saved')) {
            const saved = el.getAttribute('data-tabindex-saved');
            if (saved === '') {
              el.removeAttribute('tabindex');
            } else {
              el.setAttribute('tabindex', saved);
            }
            el.removeAttribute('data-tabindex-saved');
          }
        });
      }
    }); 
  }
  function removeAriaHidden(flkty) {
    flkty.getCellElements().forEach(cell => {
      cell.removeAttribute('aria-hidden');
    });
  }

  function addSliderKeyboardNav(flkty) {
    flkty.element.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        flkty.next();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        flkty.previous();
      }
    });
  }

  var gallery_sliders = document.querySelectorAll('.gallery-grid');

  gallery_sliders.forEach(gallery_grid => {
    var flkty = new Flickity( gallery_grid, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      on: {
        ready: function() {
          syncInertToAriaHidden(this);
          addSliderKeyboardNav(this);
          //grid__heading-holder
          /*var slider = this;
          var dots = this.element.querySelector('.flickity-page-dots');
          slider.element.closest('.grid-container--gallery').append(dots);

          var prev_btn = this.element.querySelector('.flickity-prev-next-button.previous');
          slider.element.closest('.grid-container--gallery').append(prev_btn);

          var next_btn = this.element.querySelector('.flickity-prev-next-button.next');
          slider.element.closest('.grid-container--gallery').append(next_btn);

          if (this.slides.length < 2) {
            //console.log('hide', this.slides.length);
            dots.classList.add('hidden');
            prev_btn.classList.add('hidden');
            next_btn.classList.add('hidden');
          }*/

        },
        change: function() {
          syncInertToAriaHidden(this);
        },
        settle: function() {
          syncInertToAriaHidden(this);
        }
      }
    });
  }); 

  var collection_list_slider_sel = document.querySelector('.collection-list-slider');
  if ( document.body.contains(collection_list_slider_sel) ) {
    var collection_list_slider = new Flickity(collection_list_slider_sel, {
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: function() {
          syncInertToAriaHidden(this);
          addSliderKeyboardNav(this);
          var slider = this;
          loadSliderNav(this, '.collection-list__slider-nav-btn--prev', '.collection-list__slider-nav-btn--next', null);
        }, 
        change: function(index) {
          syncInertToAriaHidden(this);
        },
        settle: function() {
          syncInertToAriaHidden(this);
        }
      }
    });
  }

  var collection_sliders = document.querySelectorAll('.featured-collection__slider');

  collection_sliders.forEach(slider_container => {
    var collection_slider = new Flickity(slider_container, {
      cellAlign: 'left',
      contain: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: function() {
          var slider = this;
          var parent_container = slider.element.closest('.featured-collection');
          loadSliderNav(this, '.featured-collection__slider-nav-btn--prev', '.featured-collection__slider-nav-btn--next', parent_container);
          syncInertToAriaHidden(this);
          addSliderKeyboardNav(this);
        },
        change: function() {
          syncInertToAriaHidden(this);
        },
        settle: function() {
          syncInertToAriaHidden(this);
        }
      }
    });
  });
  
  var collection_nav_slider_sel = document.querySelector('.collections-nav__slider');
  if ( document.body.contains(collection_nav_slider_sel) ) {
    var collection_nav = new Flickity(collection_nav_slider_sel, {
      cellAlign: 'left',
      freeScroll: true,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      on: {
        ready: function() {
          removeAriaHidden(this);
        },
        change: function() {
          removeAriaHidden(this);
        },
        settle: function() {
          removeAriaHidden(this);
        }
      }
    });
  }

  var timeline_nav_slider = document.querySelector('.timeline-navigation__list');
  if ( document.body.contains(timeline_nav_slider) ) {
    var timeline_nav = new Flickity(timeline_nav_slider, {
      cellAlign: 'left',
      freeScroll: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      on: {
        ready: function() {
          syncInertToAriaHidden(this);
        },
        change: function() {
          syncInertToAriaHidden(this);
        },
        settle: function() {
          syncInertToAriaHidden(this);
        }
      }
    });

    scrollSpy('.timeline-navigation__list', {
      sectionClass: '.timeline__item',
      menuActiveTarget: '.timeline-navigation__item > a',
      offset: 200,
      // smooth scroll
      smoothScroll: true,
      smoothScrollBehavior: function(element) {
        //console.log('run "smoothScrollBehavior"...', element)
        element.scrollIntoView({ behavior: 'smooth' }) // default behavior
      }
    })
  }

  function initSignupConfirmationBtn() {
    console.log('initSignupConfirmationBtn', initSignupConfirmationBtn);
    let btn = document.querySelector('.sa-signupRegisterCompleteBtn');
    if ( document.body.contains(btn) ) {
      let container = document.querySelector('.sa-affiliateForm');
      let welcomeMsg = document.createElement('p');
      welcomeMsg.classList.add('pro-signup-welcome');
      welcomeMsg.classList.add('body-size-4');
      welcomeMsg.innerHTML = "Thank you for signing up for Professional Portal! Your application is currently being reviewed, and your exclusive access will be activated routinely within less than 24hrs. Please expect a slightly longer response time during weekend or holidays of 48-72hrs.";
      container.prepend(welcomeMsg);
      btn.href = "/pages/professionals";
      btn.style.display = "none";
      let customMessaging = document.querySelector('[data-section-type="custom-code"]');
      if ( document.body.contains(customMessaging) ) {
        customMessaging.style.display = "none";
      }
    } else {
      setTimeout(initSignupConfirmationBtn, 300);
    }
  }

  function initNewsletterCheckbox() {
    function replaceNewsletterSpan() {
      const checkboxRow = document.querySelector('.sa-checkboxRow');
      if (!checkboxRow) return;
      if (checkboxRow.querySelector('label[for="sa-newsletter-input"]')) return; // already replaced
      const span = checkboxRow.querySelector('span');
      if (!span) return;
      const label = document.createElement('label');
      label.setAttribute('for', 'sa-newsletter-input');
      label.textContent = span.textContent;
      span.parentNode.replaceChild(label, span);
    }

    replaceNewsletterSpan();

    // SA app re-renders the form after our code runs, swapping in a fresh span.
    // Watch for those re-renders and re-apply the replacement each time.
    let debounce = null;
    const observer = new MutationObserver(function() {
      clearTimeout(debounce);
      debounce = setTimeout(replaceNewsletterSpan, 50);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Disconnect after 30s once SA's rendering has settled
    setTimeout(function() {
      observer.disconnect();
      clearTimeout(debounce);
    }, 30000);
  }

  function initProSignupForm() {
    let popUp = document.getElementById('sa-modal');
    if (document.body.contains(popUp)) {
      popUp.style.display = "none";
    }
    initNewsletterCheckbox();
    initSignupConfirmationBtn();
  }

  function watchForSAToastAccessibility() {
    function labelToast(toast) {
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.setAttribute('aria-atomic', 'true');
      // Make the SVG close button keyboard-accessible
      const svg = toast.querySelector('svg');
      if (svg && svg.tagName === 'SVG') {
        svg.setAttribute('role', 'button');
        svg.setAttribute('tabindex', '0');
        svg.setAttribute('aria-label', 'Close notification');
        svg.removeAttribute('focusable');
        if (!svg._saA11yKeydown) {
          svg._saA11yKeydown = true;
          svg.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              svg.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
          });
        }
      }
    }

    // Label any toast already present
    const existing = document.getElementById('sa-toast');
    if (existing) labelToast(existing);

    // Watch for SA injecting or re-injecting the toast
    const observer = new MutationObserver(function(mutations) {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.id === 'sa-toast') { labelToast(node); return; }
          const inner = node.querySelector && node.querySelector('#sa-toast');
          if (inner) { labelToast(inner); return; }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initAffiliateDashboard() {
    let reinit = true;

    watchForSAToastAccessibility();

    let heading = document.querySelector('.sa-PageTitle');
    if (document.body.contains(heading)) {
      heading.style.display = "none";
    }

    let linkTable = document.querySelector('.sa-linkTable');
    if ( document.body.contains(linkTable) ) {
      addQRLink();
      reinit = false;

      
    }

    let signupForm = document.getElementById('sa-signup-form');
    if ( document.body.contains(signupForm) ) {
      initProSignupForm();
      reinit = false;
    }

    if (reinit) {
      setTimeout(initAffiliateDashboard, 300);
    }
  }


  var qrto;
  function addQRLink() {

    clearTimeout(qrto);
    //console.log('checkqr');
    let linkTable = document.querySelector('.sa-linkTable');
    if ( document.body.contains(linkTable) ) {

      let introMessage = document.getElementById('qr-intro');
      if ( !document.body.contains(introMessage) ) {
        let affContainer = document.getElementById('sa-container');
        introMessage = document.createElement("p");
        introMessage.id = 'qr-intro';
        introMessage.style.textWrap = 'pretty';
        introMessage.innerHTML = 'Download your unique QR code below and share with your fans and followers or share as a unique link to start generating income today!';
        affContainer.insertBefore(introMessage, linkTable);
      }

      let linkContainer = linkTable.querySelectorAll('.sa-linkWrapper');
      linkContainer.forEach((container, i) => {
        let linkInput = container.querySelector('input');
        if (linkInput) {
          //console.log('linkInput', linkInput);
          if (linkInput.value) {
            /*console.log('value', linkInput.value);
            const qrButton = document.createElement('button');
            qrButton.classList.add('qr-code-btn');
            qrButton.title = "View Your QR Code";
            qrButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 96l0 64 64 0 0-64L64 96zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zm64 16l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm80 64l-64 0 0 64 64 0 0-64zM256 304c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-160zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"/></svg> <span>QR Code</span>';
            qrButton.addEventListener('click', (e) => {
              e.preventDefault();*/
              let qrId = 'qr-' + i;
              let qrContainer = document.getElementById(qrId);
              if ( !document.body.contains(qrContainer) ) {
                var tr =  container.parentNode.parentNode;
                var qrTr = document.createElement('tr');
                qrContainer = document.createElement('td');
                qrContainer.colSpan = 5;
                qrContainer.id = qrId;
                qrContainer.classList.add('qr-code-container')
                qrTr.appendChild(qrContainer);
                tr.after(qrTr);
                var qrcode = new QRCode(qrContainer, {
                  text: linkInput.value,
                  width: 1000,
                  height: 1000,
                  colorDark : "#000000",
                  colorLight : "#ffffff",
                  correctLevel : QRCode.CorrectLevel.H
                });

                let link = document.createElement('a');
                link.download = 'giovanni-qrcode.png';
                link.textContent = "Download";
                link.href = qrContainer.querySelector('canvas').toDataURL();
                link.classList.add('btn');
                link.classList.add('btn--primary');
                link.classList.add('btn--solid');
                qrContainer.appendChild(link);
              }
              
              
            /*});
            container.append(qrButton);*/
            qrto = setTimeout(addQRLink, 500);
          } else {
            
            qrto = setTimeout(addQRLink, 300);
          }
        }
      });
    } else {
      qrto = setTimeout(addQRLink, 300);
    }
  }
  if (document.body.getAttribute('id') === 'affiliate-dashboard' || document.body.getAttribute('id') === 'professional-signup') {
    initAffiliateDashboard();
  }

  // This event will be fired whenever a different subscription option is selected
  document.addEventListener('sealsubs:price_update', function(e) {

    var cart_bar = document.getElementById('cart-bar');
    var price_element = cart_bar.getElementsByClassName("product__price")[0];
    var price = e.detail.price / 100;
    //console.log(price);
    var formatted_price = theme.moneyFormat.replace('{{amount}}', price);
    price_element.innerHTML = '<span data-product-price>' + formatted_price + '</span>';

    // e.detail will contain the following JSON object:
    // {
    // 		price			: currentPrice,					// Represents the current product price (including discounts)
    // 		compareAtPrice	: compareAtPrice,				// Represents the "compare at price" for the product (without discounts)
    // 		element			: subscriptionWidgetElement,	// Contains an HTML element of the widget where this change happened
    // 		pricePerDelivery: pricePerDelivery				// Represents the price per delivery (for prepaid subscriptions)

    // pricePerUnit contains price per unit info for stores in some European countries (Germany, France, etc.). ->
    // The widget has to be installed to allow the app to calculate these values. ->
    // Will be empty if the shop is not eligible for this calculations.
    // 		pricePerUnit	: {								
    // 			pricePerUnit			: (integer),		// Represents the price per unit in cents (e.g. 5000)
    // 			unit					: (string),			// Represents the unit (e.g. kg)
    // 			pricePerUnitFormatted	: (string)			// Represents the formatted price per unit (e.g. 18,00€/kg)
    // 		}
    // }
  });

  jdgmSettings.scrollTopOffset = document.querySelector('.theme__header').offsetHeight;

  var mgall = document.querySelector('.masonry-gallery');
  if ( document.body.contains(mgall) ) {
    var masonryGallery = new MiniMasonry({
      container: mgall,
      baseWidth: 370
    });
  }

  function setReferrred() {
    if (document.body.classList.contains('product-exclude-discount')) {
      window.location.replace('/');
    }
    document.body.classList.add('is-referred');
  }


  // Check for utm_source=simple-affiliate in URL or show toast from session storage
  function checkForSimpleAffiliateSource() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    
    if (utmSource === 'simple-affiliate') {
      // Start polling for the sa-toast element
      pollForSAToast();
    } else {
      // Check if we have a saved toast in session storage
      const savedToast = sessionStorage.getItem('sa-toast-content');
      if (savedToast) {

        setReferrred();

        // Create and display the toast with the saved content
        const toastElement = document.createElement('div');
        toastElement.id = 'sa-toast-saved';
        toastElement.innerHTML = savedToast;
        document.body.appendChild(toastElement);

        // Add click event to the SVG in the toast
        const closeIcon = toastElement.querySelector('svg');
        if (closeIcon) {
          closeIcon.addEventListener('click', function() {
            // Add closing class for animation
            toastElement.classList.add('closing');
            
            // Remove the element after animation completes
            setTimeout(() => {
              if (toastElement.parentNode) {
                toastElement.parentNode.removeChild(toastElement);
              }
            }, 300);
          });
        }
      }
    }
  }

  // Poll for the sa-toast element
  function pollForSAToast() {
    const checkInterval = setInterval(() => {
      const saToastElement = document.getElementById('sa-toast');
      
      if (saToastElement) {
        // Element found, save content to session storage
        const toastContent = saToastElement.innerHTML;
        sessionStorage.setItem('sa-toast-content', toastContent);

        setReferrred();
        
        // Stop polling once found
        clearInterval(checkInterval);
      }
    }, 300); // Check every 300ms
    
    // Stop polling after 20 seconds to prevent infinite polling
    setTimeout(() => {
      clearInterval(checkInterval);
    }, 20000);
  }

  // Run the check when page loads
  checkForSimpleAffiliateSource();


  let additionalCta = document.getElementById('additional-cta-data');
  let additionalCtaData = [];

  if (additionalCta) {
    try {
      additionalCtaData = JSON.parse(additionalCta.textContent);
    } catch (error) {
      console.error('Unable to parse additional CTA data.', error);
    }
  }

  function initExternalLinkModal(link) {
    //const modal = document.getElementById('external-link-modal');
    // Show a popup modal to inform the user
          // Create modal if it doesn't exist
          let modal = document.getElementById('external-link-modal');
          if (!modal) {
            modal = document.createElement('div');
            modal.id = 'external-link-modal';

            // Modal content
            const modalContent = document.createElement('div');

            const message = document.createElement('div');
            message.innerHTML = '<p><strong>You are now leaving giovannicosmetiv.com and will be redirected to Amazon.com.</strong></p><p>Product availability, pricing, and inventory are determined by Amazon and are subject to change. Not all products may be available or in stock on Amazon. Discounts and promotions on our site do not apply on Amazon. For any questions or assistance with your order on Amazon, please contact the Amazon seller directly.</p>'
            //message.innerHTML = '<p><strong>You are about to leave our site and continue shopping on Amazon.</strong></p><p>Please note: Discounts and promotions on our site do not apply on Amazon. For any questions or assistance with your order on Amazon, please contact the Amazon seller directly.</p>';

            const continueBtn = document.createElement('button');
            continueBtn.classList.add('btn', 'btn--primary', 'btn--solid', 'btn--large', 'btn--full');
            continueBtn.textContent = 'Continue';

            const cancelBtn = document.createElement('button');
            cancelBtn.textContent = 'Cancel';
            cancelBtn.classList.add('btn', 'btn--full');

            const closeBtn = document.createElement('button');
            closeBtn.textContent = '✕';
            closeBtn.classList.add('modal-close');

            modalContent.appendChild(closeBtn);
            modalContent.appendChild(message);
            modalContent.appendChild(continueBtn);
            modalContent.appendChild(cancelBtn);
            modal.appendChild(modalContent);
            document.body.appendChild(modal);

            // Hide modal on cancel
            cancelBtn.addEventListener('click', function() {
              modal.style.display = 'none';
            });
            closeBtn.addEventListener('click', function(e) {
              modal.style.display = 'none';
            });

            // Hide modal if user clicks outside modal content
            modal.addEventListener('click', function(e) {
              if (e.target === modal) {
                modal.style.display = 'none';
              }
            });

            // Store continueBtn for later use
            modal._continueBtn = continueBtn;
          }

          // Set up the continue button to open the link in a new tab
          modal._continueBtn.onclick = function() {
            window.open(link, '_blank', 'noopener,noreferrer');
            modal.style.display = 'none';
          };

          // Show the modal
          modal.style.display = 'flex';

          const closeBtn = modal.querySelector('.modal-close');
          if (closeBtn) {
            closeBtn.focus();
          }

        
  }

  const setAdditionalCta = function(variantId) {
    if (additionalCta) {
      const submitButtons = additionalCta.previousElementSibling?.querySelector('.product__submit__buttons');
      if (!submitButtons) return;

      // Remove the previous CTA even when the newly selected variant has none.
      submitButtons.querySelectorAll('.additional-cta-btn').forEach(btn => btn.remove());

      const selectedCta = additionalCtaData.find(cta => cta.variant_id === Number(variantId));
      if (selectedCta) {
        // Create the new link/button
        const ctaBtn = document.createElement('a');
        ctaBtn.href = selectedCta.cta_link || '#';
        ctaBtn.target = selectedCta.cta_target || '_blank';
        ctaBtn.className = `btn additional-cta-btn ${selectedCta.cta_class || ''}`;
        ctaBtn.textContent = selectedCta.cta_text || 'Buy on Amazon';

        if (ctaBtn.target === '_blank') {
          ctaBtn.rel = 'noopener noreferrer';
        }

        if (selectedCta.cta_class && selectedCta.cta_class.includes('redirect-msg')) {
          ctaBtn.addEventListener('click', (e) => {
            e.preventDefault();
            
            initExternalLinkModal(selectedCta.cta_link);
          });
        }

        submitButtons.appendChild(ctaBtn);
      }
    }
  }
  document.addEventListener('theme:variant:change', function(e) {
    console.log('theme:variant:change', e.detail.variant.id);
    setAdditionalCta(e.detail.variant.id);
  });

  if (additionalCta) {
    setAdditionalCta(additionalCta.dataset.selectedVariantId);
  }

  function addAmazonCartButtonListener() {
    const cartContainer = document.getElementById('rebuy-cart');
    if (cartContainer) {
    const amazonCartButton = cartContainer.querySelector('.cart-banner a');
      //console.log('amazonCartButton', amazonCartButton);
      if (amazonCartButton) {
        amazonCartButton.addEventListener('click', function(e) {
          e.preventDefault();
          initExternalLinkModal(amazonCartButton.href);
          //window.open(amazonCartButton.href, '_blank', 'noopener,noreferrer');
        });
      }
    } else {
      setTimeout(addAmazonCartButtonListener, 1000);
    }
  }

  document.addEventListener('rebuy:cart.ready', (event) => { 
    addAmazonCartButtonListener();
  });


document.addEventListener('DOMContentLoaded', function() {
  const formErrors = document.getElementById('form-errors');
  if (formErrors && formErrors.textContent.trim()) {
    formErrors.focus();
  }

  initTranscriptToggles();
});

function initTranscriptToggles(root) {
  var scope = root || document;
  scope.querySelectorAll('[class*="__transcript-toggle"]').forEach(function(btn) {
    if (btn._transcriptInitialised) return;
    btn._transcriptInitialised = true;
    btn.addEventListener('click', function() {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var body = document.getElementById(btn.getAttribute('aria-controls'));
      if (!body) return;
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        body.setAttribute('hidden', '');
        body.setAttribute('tabindex', '-1');
        btn.focus();
      } else {
        body.removeAttribute('hidden');
        body.setAttribute('tabindex', '0');
        body.focus();
      }
    });
  });
}
window.initTranscriptToggles = initTranscriptToggles;


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})(themeVendor.Flickity, themeVendor.PhotoSwipe);


(function () {
  const labelFrame = (iframe) => {
    // Skip if already labeled
    if (iframe.hasAttribute("title") || iframe.hasAttribute("aria-label") || iframe.hasAttribute("aria-labelledby")) return;

    // Try to infer a good label (customize these heuristics)
    const src = iframe.getAttribute("src") || "";
    let title = "Embedded content";

    if (src.includes("youtube.com") || src.includes("youtu.be")) title = "YouTube video";
    if (src.includes("hulkapps.com")) title = "Contact form";
    if (src.includes("vimeo.com")) title = "Vimeo video";
    if (src.includes("google.com/maps")) title = "Map";
    if (src.includes("recaptcha")) title = "Security challenge";
    if (src.includes("chat")) title = "Chat widget";

    iframe.setAttribute("title", title);
  };

  // Label any existing iframes now
  document.querySelectorAll("iframe").forEach(labelFrame);

  // Observe future inserts
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.tagName === "IFRAME") labelFrame(node);
        node.querySelectorAll?.("iframe").forEach(labelFrame);
      }
    }
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();

// Accessibility enhancement for Klaviyo pop-up forms: when a form is submitted, set focus to the form and update its aria-label to include the text of any rich text elements in the form, so that screen reader users get confirmation of what they just submitted. Only applies to specific form IDs to avoid interfering with other Klaviyo forms that may be present for other purposes (e.g. cart abandonment).
window.addEventListener('klaviyoForms', (e) => {
  const targetForms = ['T78e4H', 'QYG4NT'];

  if (e.detail.type !== 'submit') return;
  if (!targetForms.includes(e.detail.formId)) return;

  setTimeout(() => {
    const form = document.querySelector(
      `[data-testid="klaviyo-form-${e.detail.formId}"]`
    );
    if (!form) return;

    const richTexts = form.querySelectorAll('.klaviyo-form-richtext');

    const combined = [richTexts[0], richTexts[1]]
      .filter(Boolean)
      .map((el) => el.textContent.trim())
      .join(' ');

    form.setAttribute('tabindex', '-1');
    form.setAttribute('aria-label', combined);
    form.focus();
  }, 300);
});
